import { NgModule } from '@angular/core';
import { DatexPipe } from './datex.pipe';
import { SafePipe } from './safehtml.pipe';
import { OrderByPipe } from './orderby.pipe';
import { SafeUrlPipe } from './safe-url.pipe';
import { UcfirstPipe } from './ucfirst.pipe';

@NgModule({
  imports: [],
  declarations: [DatexPipe, SafePipe, OrderByPipe, SafeUrlPipe,UcfirstPipe],
  exports: [DatexPipe, SafePipe, OrderByPipe,SafeUrlPipe,UcfirstPipe]
})
export class CustompipeModule {
  static forRoot() {
    return {
      ngModule: CustompipeModule,
      providers: []
    };
  }
}
